// ----------------------------------------------------------------------

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.secondary.main,
        },
        arrow: {
          color: theme.palette.secondary.main,
        },
      },
    },
  };
}
